/** Persist when the assistant last spoke a greeting / handled a turn. */
export const ASSISTANT_LAST_ACTIVITY_KEY = 'ofrontend.assistantLastActivityAt';
/** Set by Clear / New search so the next open (or immediate speak) greets again. */
export const ASSISTANT_GREET_AFTER_CLEAR_KEY = 'ofrontend.assistantGreetAfterClear';

export const ASSISTANT_GREETING_IDLE_MS = 60 * 60 * 1000;

function readNumber(key: string): number | null {
  if (typeof localStorage === 'undefined') {
    return null;
  }
  try {
    const raw = localStorage.getItem(key);
    if (raw == null || raw === '') {
      return null;
    }
    const n = Number(raw);
    return Number.isFinite(n) ? n : null;
  } catch {
    return null;
  }
}

function writeNumber(key: string, value: number): void {
  if (typeof localStorage === 'undefined') {
    return;
  }
  try {
    localStorage.setItem(key, String(value));
  } catch {
    /* ignore */
  }
}

function writeFlag(key: string, on: boolean): void {
  if (typeof localStorage === 'undefined') {
    return;
  }
  try {
    if (on) {
      localStorage.setItem(key, '1');
    } else {
      localStorage.removeItem(key);
    }
  } catch {
    /* ignore */
  }
}

function readFlag(key: string): boolean {
  if (typeof localStorage === 'undefined') {
    return false;
  }
  try {
    return localStorage.getItem(key) === '1';
  } catch {
    return false;
  }
}

export function markAssistantClearedForGreeting(): void {
  writeFlag(ASSISTANT_GREET_AFTER_CLEAR_KEY, true);
}

export function markAssistantVoiceActivity(now = Date.now()): void {
  writeNumber(ASSISTANT_LAST_ACTIVITY_KEY, now);
  writeFlag(ASSISTANT_GREET_AFTER_CLEAR_KEY, false);
}

/** True after Clear/New search, or when idle ≥ 1 hour (including first use). */
export function shouldSpeakAssistantGreeting(now = Date.now()): boolean {
  if (readFlag(ASSISTANT_GREET_AFTER_CLEAR_KEY)) {
    return true;
  }
  const last = readNumber(ASSISTANT_LAST_ACTIVITY_KEY);
  if (last == null) {
    return true;
  }
  return now - last >= ASSISTANT_GREETING_IDLE_MS;
}

/** Call when a greeting is actually spoken. */
export function consumeAssistantGreeting(now = Date.now()): void {
  markAssistantVoiceActivity(now);
}

/** Test-only. */
export function resetAssistantVoiceSessionForTests(): void {
  if (typeof localStorage === 'undefined') {
    return;
  }
  try {
    localStorage.removeItem(ASSISTANT_LAST_ACTIVITY_KEY);
    localStorage.removeItem(ASSISTANT_GREET_AFTER_CLEAR_KEY);
  } catch {
    /* ignore */
  }
}
